import { render, staticRenderFns } from "./ViewOrganization.vue?vue&type=template&id=1463c054&"
import script from "./ViewOrganization.vue?vue&type=script&lang=js&"
export * from "./ViewOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports